import { parseIsoToDisplay } from '@common/utils/formatDuration';
import { Badge, Flex, Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

export const EmptyFormatter = () => {
    const { t } = useTranslation('metadataEditor');
    return (
        <Text color='gray' style={{ fontStyle: 'italic' }}>
            {t('formatters.empty', 'Vide')}
        </Text>
    );
};

export const ArrayFormatter = ({ value }: { value: unknown[] }) => {
    if (value.length === 0) return <EmptyFormatter />;

    return (
        <Flex gap='2' wrap='wrap' justify='start'>
            {value.map((item, index) => (
                <Badge key={index} variant='surface' color='gray'>
                    {String(item)}
                </Badge>
            ))}
        </Flex>
    );
};

export const BooleanFormatter = ({ value }: { value: boolean }) => {
    const { t } = useTranslation('metadataEditor');
    return (
        <Text>
            {value
                ? t('formatters.boolean.true', 'Oui')
                : t('formatters.boolean.false', 'Non')}
        </Text>
    );
};

export const DurationFormatter = ({ value }: { value: unknown }) => {
    const displayValue =
        typeof value === 'string' ? parseIsoToDisplay(value) : String(value);

    return <Text>{displayValue}</Text>;
};

export const DefaultFormatter = ({ value }: { value: unknown }) => (
    <Text>{String(value)}</Text>
);
